import * as React from "react"
import * as Yup from "yup"
import Form, { FormElement } from "@modules/form/components/Form"
import { MdArrowForward } from "react-icons/md"
import {
  Button,
  InputConnectedField,
  StyledModalActions,
  Text,
} from "gatsby-interface"
import {
  azureIntegrationConfig as text,
  ui as uiText,
} from "@modules/locales/default.js"
import { useConnectAzureToSiteMutation } from "@modules/cdn/azure/queries.generated"
import { CdnIntegrationSharedProps } from "@modules/cdn/shared/types"

type FormValues = {
  connectionString: string
  storageAccount: string
}

const validationSchema = Yup.object().shape<FormValues>({
  connectionString: Yup.string().required(uiText.messages.validationIsRequired),
  storageAccount: Yup.string().required(uiText.messages.validationIsRequired),
})

export type AzureIntegrationFormProps = CdnIntegrationSharedProps

export function AzureIntegrationForm({
  siteId,
  integration,
  onSetCDNConfig,
  onSubmitFailed,
  onCancel,
}: AzureIntegrationFormProps) {
  const [mutate] = useConnectAzureToSiteMutation()

  return (
    <Form<FormValues>
      validationSchema={validationSchema}
      initialValues={{
        connectionString: integration?.config?.connectionString ?? ``,
        storageAccount: integration?.config?.storageAccount ?? ``,
      }}
      onSubmit={values => {
        mutate({
          variables: {
            siteId,
            config: {
              connectionString: values.connectionString,
              storageAccount: values.storageAccount,
            },
          },
        })
          .then(({ data }) => {
            return onSetCDNConfig({
              success: data?.connectAzureToSite?.success ?? false,
              errorType: data?.connectAzureToSite?.errorType,
            })
          })
          .catch(onSubmitFailed)
      }}
    >
      {({ isSubmitting }) => (
        <FormElement applySpacing noValidate>
          <Text css={{ margin: 0 }}>{text.messages.introText}:</Text>
          <InputConnectedField
            name="connectionString"
            label={text.labels.azureConnectionString}
            required
          />
          <InputConnectedField
            name="storageAccount"
            label={text.labels.azureStorageAccount}
            required
          />

          <StyledModalActions>
            <Button variant="SECONDARY" type="reset" onClick={onCancel}>
              {uiText.actions.cancel}
            </Button>
            <Button
              type="submit"
              loading={isSubmitting}
              rightIcon={<MdArrowForward />}
            >
              {uiText.actions.save}
            </Button>
          </StyledModalActions>
        </FormElement>
      )}
    </Form>
  )
}
